import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import MaterialTable from "material-table";
import { styled } from "@mui/material/styles";
import clsx from "clsx";
import { PERMISSIONS_TABLE_COLUMNS } from "constants/ui-constants";
import { getColumns, getActions, getLocalization } from "util/table-utils";
import { mapTableData } from "util/helpers";
import { PATHS } from "util/appConstants";
import withConfirm from "components/dialogs/delete";
import Navbar from "components/Navbar";
import DarkLayout from "components/Shared/DarkLayout";
import { selectUser } from "redux/slices/userSlice";
import { getAllPermissions, selectPermissions, selectPermissionsStatus } from "redux/slices/permissionsSlice";

// Using MUI's new sx prop for styles or use styled components
const FilterIcon = styled("i")(({ theme }) => ({
  color: "#525252",
  fontSize: "12px",
}));

const tableTitle = "PERMISSIONS";

const PermissionList = ({ confirm }) => {
  const { t, i18n } = useTranslation("common");
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(selectUser);

  const loading = useSelector(selectPermissionsStatus);
  const permissions = useSelector(selectPermissions);
  useEffect(() => {
    dispatch(getAllPermissions());
  }, [dispatch]);
  
  const canEditPermissions =
    user?.isSuperAdmin ||
    Boolean(user?.admin && import.meta.env.VITE_PERMISSION_EDITABLE_BY_ADMIN === "true");

  const actions = canEditPermissions
    ? getActions(
        tableTitle,
        () => () => {},
        () => addHandler(),
        null,
        null,
        null,
        t,
        user
      )
    : [];
  const addHandler = () => {
    history.push(PATHS.admin.permissionAdd);
  };
  return (
    <>
      <Navbar />
      <DarkLayout doublebar loading={loading}>
        <div className="custom-table-styles">
          <MaterialTable
            icons={{
              Filter: () => <FilterIcon className={clsx("fas fa-filter")} />,
            }}
            style={{ display: "flex", flexDirection: "column" }}
            data={mapTableData(permissions)}
            title={t(tableTitle)}
            columns={getColumns(PERMISSIONS_TABLE_COLUMNS(t, i18n), t)}
            onRowClick={(e, rowData) => history.push(PATHS.admin.permissionsDetail.replace(":id", rowData.id))}
            actions={actions}
            localization={getLocalization(t)}
            options={{
              pageSize: 50,
              pageSizeOptions: [50, 100],
              actionsColumnIndex: -1,
              searchFieldAlignment: "left",
              showTitle: false,
              filtering: true,
              emptyRowsWhenPaging: false,
              headerStyle: {
                backgroundColor: "#121212",
                color: "white",
                borderBottom: "1px solid #525252",
                font: "normal normal normal 12px/24px Roboto",
                fontWeight: "bold",
              },
              cellStyle: {
                backgroundColor: "#121212",
                color: "white",
                border: "none",
                font: "normal normal normal 12px/24px Roboto",
                padding: "0 16px",
              },
              searchFieldStyle: {
                color: "#F5F5F5",
              },
              filterCellStyle: {
                color: "#F5F5F5",
              },
              rowStyle: { height: "38px" },
            }}
          />
        </div>
      </DarkLayout>
    </>
  );
};

export default withConfirm(PermissionList);
